// jshint esversion:6
import Resource from './resource'

const resources = {
  users: new Resource('/users'),
  quotes: new Resource('/quotes'),
  trips: new Resource('/trips'),
  stops: new Resource('/stops'),
  planners: new Resource('/planners'),
  dates: new Resource('/dates'),
  amenities: new Resource('/amenities'),
  login: new Resource('/login'),
  logout: new Resource('/logout'),
  dispatchers: new Resource('/dispatchers'),
  operators: new Resource('/operators'),
  rates: new Resource('/rates'),
  emails: new Resource('/emails'),
  templates: new Resource('/emails/templates'),
};

export default {
  get: name => resources[name]
};
